export enum EnvironmentType {
  DEV = 'local',
  STG = 'stg',
  PROD = 'prod',
}
